import { enqueueSnackbar } from '@common-modules/snackbar';
import {
  actionApplyDeleteTranscription,
  DELETE_TRANSCRIPTION_RESULTS,
  DELETE_TRANSCRIPTION_RESULTS_FAILURE,
  DELETE_TRANSCRIPTION_RESULTS_SUCCESS,
} from '../actions/transcription';
import { deleteTranscriptionResults } from '../services';
import { sagaIntl } from '@i18n';
import { IN_APPLY_DELETE_TRANSCRIPTION } from '@common/web-worker';
import { race, take, takeLatest, put } from 'typed-redux-saga/macro';

export function* watchDeleteTranscriptionResults() {
  yield* takeLatest(
    DELETE_TRANSCRIPTION_RESULTS,
    handleDeleteTranscriptionResults
  );
}

function* handleDeleteTranscriptionResults({
  payload: { removeAudioRedactions, removeVoiceMask },
}: ReturnType<typeof DELETE_TRANSCRIPTION_RESULTS>) {
  yield* put(deleteTranscriptionResults());

  const { success } = yield* race({
    success: take(DELETE_TRANSCRIPTION_RESULTS_SUCCESS),
    failure: take(DELETE_TRANSCRIPTION_RESULTS_FAILURE),
  });

  const intl = sagaIntl();

  if (success) {
    const metadata = {
      description: intl.formatMessage({
        id: 'deleteTranscriptionHistory',
        defaultMessage: 'delete transcription',
      }),
    };

    yield* put(
      actionApplyDeleteTranscription({ removeAudioRedactions, removeVoiceMask })
    );
    yield* put(
      IN_APPLY_DELETE_TRANSCRIPTION({
        removeAudioRedactions,
        removeVoiceMask,
        metadata,
      })
    );
    yield* put(
      enqueueSnackbar({
        message: intl.formatMessage({
          id: 'deleteTranscriptionSuccess',
          defaultMessage: 'Transcription deleted successfully',
        }),
      })
    );
    return;
  }

  yield* put(
    enqueueSnackbar({
      message: intl.formatMessage({
        id: 'deleteTranscriptionFailure',
        defaultMessage: 'Failed to delete transcription',
      }),
    })
  );
}
